function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
// Material imports
import MuiCheckBox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
const Icon = styled("span")(({
  theme
}) => {
  return {
    borderRadius: 4,
    width: 20,
    height: 20,
    backgroundColor: "transparent",
    // outline: `1px auto ${theme.palette.primary.light}`,
    borderColor: theme.palette.primary.light,
    borderStyle: "solid",
    borderWidth: "1px",
    backgroundImage: theme.palette.mode === "dark" ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))" : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {},
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5"
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: theme.palette.mode === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)"
    }
  };
});
const CheckedIcon = styled(Icon)(({
  theme
}) => {
  return {
    backgroundColor: theme.palette.primary.light,
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 20,
      height: 20,
      backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 20 20'%3E%3Cpath" + " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " + "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      // eslint-disable-next-line quotes
      content: '""'
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.primary.light
    }
  };
});
const CheckBox = ({
  onLabel = "",
  offLabel = "",
  checked = false,
  onCheckedChanged,
  variantStyling = {},
  labelVariant = "body2",
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const {
    id = `${onLabel.trim().toLowerCase() || "no_label"}_check`
  } = {
    ...rest
  };
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    id: `${id}-label`,
    componentsProps: {
      typography: {
        variant: labelVariant
      }
    },
    control: /*#__PURE__*/React.createElement(MuiCheckBox, _extends({
      "aria-labelledby": `${id}-label`,
      checked: checked,
      sx: variantStyling,
      checkedIcon: /*#__PURE__*/React.createElement(CheckedIcon, null),
      onClick: onCheckedChanged,
      icon: /*#__PURE__*/React.createElement(Icon, null),
      disableRipple: true
    }, rest)),
    label: checked ? t(onLabel) : t(offLabel)
  });
};
CheckBox.propTypes = {
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  checked: PropTypes.bool,
  onCheckedChanged: PropTypes.func,
  variantStyling: PropTypes.object,
  labelVariant: PropTypes.string
};
export default CheckBox;